function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "chart");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "chart",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Chart-Copy",
  transform: "translate(-7.000000, -7.000000)",
  stroke: "currentColor",
  strokeWidth: 4
}, React.createElement("g", {
  id: "Chart",
  transform: "translate(32.000000, 32.000000) rotate(45.000000) translate(-32.000000, -32.000000) translate(11.000000, 9.000000)"
}, React.createElement("g", {
  id: "Group-12",
  transform: "translate(9.525126, 0.882991)"
}, React.createElement("path", {
  d: "M0.1626896,2.74924892 L10.4649294,14.2986162 L20.9780994,2.90290468 C17.8362005,1.01925589 14.2181623,0 10.44,0 C6.7669559,0 3.24467143,0.96311569 0.1626896,2.74924892 Z",
  id: "Combined-Shape"
})), React.createElement("g", {
  id: "Group-12",
  transform: "translate(0.025126, 9.060660)"
}, React.createElement("path", {
  d: "M6.89884948,0.75148503 C2.55872439,4.5358591 0,9.9768448 0,15.8378378 C0,26.966263 9.1714464,36 20.5,36 C31.8285536,36 41,26.966263 41,15.8378378 C41,10.0830191 38.5338303,4.73107959 34.3288386,0.95322771 L20.475147,15.8638004 L6.89884948,0.75148503 Z",
  id: "Combined-Shape"
})))));

var SvgChart = function SvgChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart.321390f1.svg";
export { ForwardRef as ReactComponent };